import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { generatePath, useHistory, useParams } from 'react-router';
import RouterNavigationTabs from '@/components/organisms/RouterNavigationTabs';
import { Routes } from '@/core/router/routes.types';
import { _routes as routes } from '@/core/router/routes';
import { getUserToken } from '@/redux/user';
import { useGetBrandRestaurantsQuery } from '@/services/innovorder/brand/brand.endpoints';
import { usePostShiftMutation } from '@/services/innovorder/shift/shift.endpoints';
import { stringifyError } from '@/utils/errors';
import { ShiftForm, ShiftFormSubmitPayload } from '@/pages/Brand/ShiftForm';

const CreateShift: React.FunctionComponent<React.PropsWithChildren> = () => {
    const history = useHistory();
    const { brandId } = useParams<{ brandId: string }>();
    const token = useSelector(getUserToken);

    const tabRoutes = useMemo(() => routes.filter(({ tab }) => tab === 'brands'), []);

    const { data: restaurants = [] } = useGetBrandRestaurantsQuery({ brandId: parseInt(brandId, 10), token });

    const [postShift, { isSuccess, error, isLoading }] = usePostShiftMutation();

    useEffect(() => {
        if (isSuccess) {
            history.push(generatePath(Routes.Shifts, { brandId }));
        }
    }, [isSuccess, history, brandId]);

    return (
        <RouterNavigationTabs routes={tabRoutes}>
            <ShiftForm
                mode="create"
                restaurants={restaurants}
                isLoading={isLoading}
                error={stringifyError(error)}
                onSubmit={(payload: ShiftFormSubmitPayload) =>
                    postShift({ ...payload, brandId: parseInt(brandId, 10), token })
                }
            />
        </RouterNavigationTabs>
    );
};

export default CreateShift;
